
import React from 'react';;

const Loading = () => {
  const logoUrlFromLocalStorage = localStorage.getItem('logoUrl');
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#fff',
        background: 'rgba(0, 0, 0, 0.30)',
        opacity: 0.7,
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <img alt="logo" src={logoUrlFromLocalStorage} style={{ height: 52, width: 105 }} />
        <img alt={'gif'} src={'/assets/ball.gif'} width={40} height={40} />
      </div>
    </div>
  );
};
export default Loading;
